import { type FilledInputProps } from "@mui/material";
import { type Dayjs } from "dayjs";
import {
  type ValidationFunction,
  type ValidationResult,
} from "utils/validation";
import { Caption, DateInput } from "./styles";
import { useTranslation } from "react-i18next";

export interface DepositDate {
  validation: ValidationResult | null;
  value: Dayjs | null;
}

export interface CfarDateInputProps {
  onChange: (value: Dayjs | null) => void;
  onValidation: (validation: ValidationResult | null) => void;
  value: Dayjs | null;
  validate: ValidationFunction<Dayjs | null>;
  isEligible?: boolean | null;
  InputProps?: Partial<FilledInputProps>;
}

export function CfarDateInput({ isEligible, ...props }: CfarDateInputProps) {
  const { t } = useTranslation("screens", {
    keyPrefix: "offer.addOns.cancelForAnyReason",
  });
  return (
    <>
      <DateInput autoFocus variant="simple" {...props} />
      {isEligible === false && (
        <Caption className="alert">
          {t("popup.errorMessages.ineligible")}
        </Caption>
      )}
      {isEligible === true && (
        <Caption className="warning">
          {t("popup.errorMessages.eligible")}
        </Caption>
      )}
    </>
  );
}
